import 'reflect-metadata'
import { define, type, auto, Record, Collection } from 'type-r'
import { openDB, deleteDB } from 'idb';

import Store from './store.js'

import EntropionForm from '#forms/entropion.js'

@define
export default class EntropionFormStore extends Store {
    @(type(EntropionForm).events({"change": "formchange"}).as) entropionForm: EntropionForm
}

const store = window.store = new EntropionFormStore({ id: "entropion" })
export { store };
